<script>
  export let size = 42;
</script>

<svg width={size} height={size} viewBox="0 0 27 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.4028 21.4672C13.4028 21.4672 22.2428 24.6572 23.1428 31.8572L26.0928 21.4672C26.0928 21.4672 19.7828 12.7772 4.32275 16.2172L13.4128 21.4672H13.4028Z"
    fill="#E8BA1A"
  />
  <path
    d="M0.392705 0.51709C0.392705 0.51709 -3.5273 16.5571 13.4027 21.4671C13.4027 21.4671 4.8927 16.8071 9.06271 3.62709L0.392705 0.51709Z"
    fill="#FFCF29"
  />
</svg>
